import React from 'react'

import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import ScrollSpy from 'react-scrollspy-navigation';
import NavDropdown from 'react-bootstrap/NavDropdown';

import Instagram from "../images/iconmonstr-instagram-13.inline.svg";
import Facebook from "../images/iconmonstr-facebook-4.inline.svg";
import Soundcloud from "../images/iconmonstr-soundcloud-4.inline.svg";
import Twitter from "../images/iconmonstr-twitter-4.inline.svg";
import Spotify from "../images/spotify-navbar.inline.svg";
import YouTubeMusic from "../images/youtube-music-navbar.inline.svg";

import 'bootstrap/dist/css/bootstrap.min.css';
import "./site-navbar.module.css"
import {
  icon,
} from './site-navbar.module.css'



const SiteNavbar = (props) => {
  
  return (
    <Navbar sticky="top" bg="black" variant="dark">
      <Navbar.Brand href="#home">AJIACO</Navbar.Brand>
      <Nav className="me-auto">
        <ScrollSpy offsetTop="48" duration="1000">
          <Nav.Link href="#canciones" ref={React.createRef()}>CANCIONES</Nav.Link>
          <Nav.Link href="#videos" ref={React.createRef()}>VIDEOS</Nav.Link>
          <Nav.Link href="#discos" ref={React.createRef()}>DISCOS</Nav.Link>
        </ScrollSpy>
        <NavDropdown title="CONTACTO" id="contact-dropdown" menuVariant="dark">
          <NavDropdown.Item href="https://www.instagram.com/bandaajiaco" target="_blank"><Instagram className={icon}/> Instagram</NavDropdown.Item>
          <NavDropdown.Item href="https://www.facebook.com/BandaAjiaco/" target="_blank"><Facebook className={icon}/> Facebook</NavDropdown.Item>
          <NavDropdown.Item href="https://twitter.com/BandaAjiaco" target="_blank"><Twitter className={icon}/> Twitter</NavDropdown.Item>
          <NavDropdown.Item href="https://open.spotify.com/artist/59xb7B3RlWrUxlxfvUdzHo?si=wBZBSeOUSoiFIGieN7asYQ" target="_blank"><Spotify className={icon}/> Spotify</NavDropdown.Item>
          <NavDropdown.Item href="https://music.youtube.com/channel/UCoVE4roIDE9nVhftj5Al9JA?feature=share" target="_blank"><YouTubeMusic className={icon}/> YouTube Music</NavDropdown.Item>
          <NavDropdown.Item href="https://soundcloud.com/bandaajiaco" target="_blank"><Soundcloud className={icon}/> Soundcloud</NavDropdown.Item>
      </NavDropdown>
      </Nav>
    
    </Navbar>
    
    )
  }


export default SiteNavbar